/* CWILL documented App Proxy navigation. No tracking results or customer data are stored here. */
(() => {
  'use strict';
  if (window.DFTracking) { window.DFTracking.init(document); return; }
  const bound = new WeakSet();
  const tokenFor = email => Array.from(email.trim()).reverse().join('').replace(/@/g, '_-_');

  function selectMode(root, mode, focus = false) {
    if (mode !== 'order' && mode !== 'parcel') return;
    root.querySelectorAll('[data-tracking-mode]').forEach(button => {
      const active = button.dataset.trackingMode === mode;
      button.setAttribute('aria-pressed', String(active));
      if (active && focus) button.focus();
    });
    root.querySelectorAll('[data-tracking-form]').forEach(form => { form.hidden = form.dataset.trackingForm !== mode; });
  }

  function prepare(form) {
    const root = form.closest('[data-df-tracking]');
    if (!root) return false;
    const status = form.querySelector('[data-tracking-status]');
    if (status) status.textContent = '';
    const number = form.querySelector('[data-tracking-order], [data-tracking-number]');
    if (!number) return false;
    number.value = number.value.trim();
    if (form.dataset.trackingForm === 'order') number.value = number.value.replace(/#/g, '').trim();
    number.setCustomValidity(number.value ? '' : root.dataset.invalid);
    const email = form.querySelector('[data-tracking-email]');
    if (email) email.value = email.value.trim();
    if (!form.checkValidity()) {
      if (status) status.textContent = root.dataset.invalid;
      form.reportValidity();
      return false;
    }
    const token = form.querySelector('[data-tracking-token]');
    if (token && email) {
      // The native GET form performs URL encoding exactly once.
      token.value = tokenFor(email.value);
      token.disabled = false;
    }
    return true;
  }

  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-df-tracking]')];
    if (scope.matches?.('[data-df-tracking]')) roots.unshift(scope);
    roots.forEach(root => {
      if (bound.has(root)) return;
      const forms = [...root.querySelectorAll('[data-tracking-form]')];
      if (!forms.length) return;
      // Never forward customer input to an unrelated origin entered in the editor.
      const valid = forms.every(form => {
        try {
          const url = new URL(form.action, window.location.href);
          if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return false;
          url.search = ''; url.hash = ''; form.action = url.href;
          return true;
        } catch (_) { return false; }
      });
      if (!valid) return;
      bound.add(root);
      root.querySelector('[data-tracking-controls]').hidden = false;
      root.querySelector('[data-tracking-fallback]').hidden = true;
      selectMode(root, 'order');
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-tracking-mode]');
    const root = button?.closest('[data-df-tracking]');
    if (root && bound.has(root)) selectMode(root, button.dataset.trackingMode);
  });
  document.addEventListener('keydown', event => {
    const button = event.target.closest('[data-tracking-mode]');
    const root = button?.closest('[data-df-tracking]');
    if (!root || !bound.has(root) || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const mode = event.key === 'Home' ? 'order' : event.key === 'End' ? 'parcel' : button.dataset.trackingMode === 'order' ? 'parcel' : 'order';
    selectMode(root, mode, true);
  });
  document.addEventListener('input', event => {
    const form = event.target.closest('[data-tracking-form]');
    if (!form) return;
    event.target.setCustomValidity?.('');
    const token = form.querySelector('[data-tracking-token]');
    if (token) { token.value = ''; token.disabled = true; }
    const status = form.querySelector('[data-tracking-status]');
    if (status) status.textContent = '';
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-tracking-form]');
    if (!form) return;
    if (!bound.has(form.closest('[data-df-tracking]')) || !prepare(form)) event.preventDefault();
    // On success, allow the native GET submission to the installed CWILL App Proxy.
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  window.DFTracking = { init };
})();
